import { Grid, Checkbox, FormControlLabel } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import CustomButton from '../../MasterComponent/Button/CustomButton';
import { OverlayLoading } from '../OverlayLoading/OverlayLoading';

interface alertModal {
  show: boolean;
  onClose?: { (): void };
  metaData: string;
  alertFunction: any;
  buttonMsg: string;
  headerMsg: string;
  buttonType?:
    | 'contained'
    | 'outlined'
    | 'warning'
    | 'danger'
    | 'info'
    | 'light'
    | 'dark';
  requireConfirmation?: boolean;
  confirmationMsg?: string;
  isLoading?: boolean;
}

const AlertModal: React.FC<alertModal> = ({
  show,
  onClose,
  metaData,
  alertFunction,
  buttonMsg,
  headerMsg,
  buttonType = 'contained',
  requireConfirmation = false,
  confirmationMsg = 'I understand the consequences of this action',
  isLoading = false,
}) => {
  const [isConfirmed, setIsConfirmed] = useState<boolean>(false);

  useEffect(() => {
    if (show) {
      setIsConfirmed(false); // Reset confirmation on modal open
    }
  }, [show]);

  const handleClose = () => {
    // Prevent closing if operation is in progress
    if (isLoading) return;
    if (onClose) onClose();
  };

  const isButtonDisabled = requireConfirmation
    ? !isConfirmed || isLoading
    : isLoading;

  return (
    <Modal
      isOpen={show}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick={!isLoading}
      bodyOpenClassName="no-scroll"
      ariaHideApp={false}
      style={{ overlay: { background: 'rgba(0,0,0,.5)', zIndex: 9999 } }}
      className="fixModal"
    >
      <Grid container spacing={0}>
        <Grid item md={12} sm={12} xs={12} className="modalHeader">
          <div>
            <span className="modalTitle">{headerMsg} Confirmation</span>
            <span
              className="modalClose"
              onClick={handleClose}
              style={{
                cursor: isLoading ? 'not-allowed' : 'pointer',
                opacity: isLoading ? 0.5 : 1,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle"
                viewBox="0 0 16 16"
              >
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </span>
          </div>
        </Grid>
        <div className="alertMessage">
          {isLoading && <OverlayLoading />}
          {metaData}

          {requireConfirmation && (
            <div
              style={{
                marginTop: '1.5rem',
                paddingTop: '1rem',
                borderTop: '1px solid #e0e0e0',
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isConfirmed}
                    onChange={(e) => setIsConfirmed(e.target.checked)}
                    color="primary"
                    disabled={isLoading}
                  />
                }
                label={
                  <span style={{ fontSize: '12px', color: '#333' }}>
                    {confirmationMsg}
                  </span>
                }
              />
            </div>
          )}
        </div>
        <div className="mt-0 modalFooter">
          <CustomButton
            buttonType={buttonType}
            onClickHandler={() => {
              alertFunction();
            }}
            disabled={isButtonDisabled}
          >
            {isLoading ? 'Processing...' : buttonMsg}
          </CustomButton>
          <button
            type="button"
            className="btn btn-outline-secondary mr-10"
            onClick={handleClose}
            disabled={isLoading}
            style={{
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.6 : 1,
            }}
          >
            Cancel
          </button>
        </div>
      </Grid>
    </Modal>
  );
};

export default AlertModal;
